import { render } from "./EditTeam.vue?vue&type=template&id=1ef00305"
import script from "./EditTeam.vue?vue&type=script&lang=js"
export * from "./EditTeam.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__